import { AppRootStateType } from 'state/store';

export const commissionSelect = (state: AppRootStateType) =>
  state.commissions.commissions;
